import { format } from 'date-fns';
import { OptionsDropdown } from 'shared/ui/OptionsDropdown';
import { GenerativeModel } from 'entities/generative-models/types';
import { Column } from 'shared/ui/tables/_common/types';
import { TableTranslationLabel } from 'shared/ui/tables/_common/ui/TableTranslationLabel';

export type GenerativeModelColumnsType = GenerativeModel & {
	id: string;
	editHandler: (model: GenerativeModel) => void;
	deleteHandler: (model: GenerativeModel) => void;
	settingsHandler: (model: GenerativeModel) => void;
	trainHandler: (model: GenerativeModel) => void;
};

export const GenerativeModelsTableColumns: Array<Column<GenerativeModelColumnsType>> = [
	{
		field: 'code',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '150px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="name" />,
		},
		bodyCellSettings: {
			renderCell: (partner) => partner?.name || '-',
		},
	},
	{
		field: 'status',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="status" />,
		},
		bodyCellSettings: {
			renderCell: (model) =>
				model?.status ? <TableTranslationLabel label={`model_status.${model?.status}`} /> : '-',
		},
	},
	{
		field: 'createdDate',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="create_date" />,
		},
		bodyCellSettings: {
			prepareField: (model) =>
				model?.createdAt ? format(new Date(model?.createdAt), 'dd/MM/yyyy') : '-',
		},
	},
	{
		field: 'lastChanges',
		commonCellSettings: {
			style: {
				minWidth: '150px',
				maxWidth: '250px',
			},
		},
		headerCellSettings: {
			renderCell: () => <TableTranslationLabel label="last_changes" />,
		},
		bodyCellSettings: {
			prepareField: (model) =>
				model?.updatedAt ? format(new Date(model?.updatedAt), 'dd/MM/yyyy') : '-',
		},
	},
	{
		field: 'options',
		commonCellSettings: {
			style: {
				minWidth: '100px',
				maxWidth: '100px',
			},
		},
		bodyCellSettings: {
			renderCell: (model) => {
				return (
					<OptionsDropdown
						iconId={'more_horizontal'}
						optionList={[
							{
								label: 'shared_texts.edit',
								value: 'Edit info',
								action: () => {
									model?.editHandler && model.editHandler(model);
								},
							},
							{
								label: 'shared_texts.table_dropdown.train',
								value: 'Train',
								action: () => {
									model?.trainHandler && model.trainHandler(model);
								},
							},
							{
								label: 'shared_texts.table_dropdown.settings',
								value: 'Settings',
								action: () => {
									model?.settingsHandler && model.settingsHandler(model);
								},
							},
							{
								label: 'shared_texts.remove',
								value: 'Remove model',
								action: () => {
									model?.deleteHandler && model.deleteHandler(model);
								},
							},
						]}
					/>
				);
			},
		},
	},
];
